import React, {Fragment} from 'react';
import './ContactForm.css'

class ContactForm extends React.Component
{
    constructor(props)
    {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit()
    {
        let frm = document.getElementById("contact-form");
        let allAreFilled = true;
        frm.querySelectorAll("[required]").forEach(function(i) {
            if (!allAreFilled) return;
            if (!i.value) allAreFilled = false;
          })
        if(allAreFilled)
        {
            frm.submit();
            frm.reset();
            alert("Thank you for contacting. I will send a reply as soon as possible.");
        }
        else
        {
            alert("Please fill in all fields of the form before submitting!")
        }
    }

    render()
    {
        return(
            <Fragment>
                <form name="contact-form" id="contact-form" action="https://docs.google.com/forms/d/e/1FAIpQLSdQZBOjjtiUEO-iR1pMpDP4OdE9jinAoufpSHZj02zks7bDEQ/formResponse?usp=pp_url" target="hidden_iframe">
                    <h3>
                    Your email address: 
                    </h3>
                    <input type="text" name="entry.1178707736" id = "entry.1178707736" required/>
                    <h3>
                    Subject: 
                    </h3>
                    <input type="text" name="entry.1443702260" id="entry.1443702260" required/>
                    <h3>
                    Message: 
                    </h3>
                    <textarea name="entry.24886754" id = "entry.24886754"
                    rows = "8" required/>

                    <input type="button" value="Submit" id="btn-submit" onClick={this.handleSubmit}/>
                </form>
                <iframe name="hidden_iframe" id="hidden_iframe" style={{display:"none"}}></iframe>
            </Fragment>
        )
    }
}

export default ContactForm